import { waitForAuth } from '~/atoms/authAtom';

const REACT_AUTH_SERVICE_URL = process.env.REACT_AUTH_SERVICE_ULR;

export const fetchToken = async (): Promise<{
  token: string;
  expiresAt: number | null;
}> => {
  // Wait for auth to be available (handles popup window race condition)
  const auth = await waitForAuth();
  const clerkToken = await auth?.auth.getToken({
    template: 'banqora_template',
  });

  if (!clerkToken) throw new Error('Clerk token is required for GraphQL auth');

  const response = await fetch(`${REACT_AUTH_SERVICE_URL}/exchange`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${clerkToken}`,
    },
  });

  if (!response.ok) throw new Error('Failed to fetch token');

  const data = await response.json();
  // The endpoint does not return expiry, so set expiresAt to null
  return { token: data?.token, expiresAt: null };
};
